import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
import MKBox from "components/MKBox";
//import MKTypography from "components/MKTypography";
//import MKSocialButton from "components/MKSocialButton";
import React, { useState, useEffect } from "react";
import { useMutation, useLazyQuery, useQuery } from "@apollo/client";
import { FIND_USER, SEND_EMAIL, GET_ACTIVATIONCODE, SAVE_CODE } from "../queries";
import { TextField, Button } from "@mui/material";
import ReCAPTCHA from "react-google-recaptcha";
import { Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import bgImage from "assets/images/strategia.jpg";
//import { set } from "lodash";
/* eslint-disable react/prop-types */
const ForgetPassword = ({ setUsertype, setError }) => {
  const [t] = useTranslation("common");
  const [email, setEmail] = useState("");
  //const [password, setPassword] = useState("");
  //const history = useHistory()
  //const bcryptjs = require("bcryptjs")
  const [emailerror, setEmailerror] = useState(false);
  const [usererror, setUsererror] = useState(false);
  const [codeerror, setCodeerror] = useState(false);
  const [getPerson, resultt] = useLazyQuery(FIND_USER);
  // eslint-disable-next-line
  const [person, setPerson] = useState(null);
  // eslint-disable-next-line
  const [token, setTokeni] = useState("");
  const [verified, setVerified] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  // eslint-disable-next-line
  const [executing, setExecuting] = useState(false);
  const [code, setCode] = useState("");
  //console.log(token);
  function rnd() {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let ran = "";
    for (let i = 0; i < 8; i = i + 1) {
      let ch = chars.charAt(Math.floor(Math.random() * chars.length));
      ran = ran.concat(ch);
    }
    return ran;
  }
  // eslint-disable-next-line
  const [rndnum, setRndnum] = useState(rnd());
  //console.log(rndnum);
  //console.log(setRndnum);
  function onChange(value) {
    //console.log("Captcha value:", value);
    setTokeni(value);
    setVerified(!verified);
  }

  // eslint-disable-next-line
  const showPerson = (email) => {    
    getPerson({
      variables: { emailToSearch: email },
    });
  };
  const [sendEmail] = useMutation(SEND_EMAIL, {
    // eslint-disable-next-line
    onError: (error) => {
      //console.log("virhe meilin lähetyksessä:" + error);
      setEmailerror(true);
      //setError(error.graphQLErrors[0].message)
      //setError(error)
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addComment)
    }*/
  });
  const [saveCode] = useMutation(SAVE_CODE, {
    onError: (error) => {
      //console.log("virhe koodin tallennuksessa:" + error);
      //setError(error.graphQLErrors[0].message)
      setCodeerror(true);
      setError(error);
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addComment)
    }*/
  });
  useEffect(() => {
    if (resultt.data) {
      setUsertype(resultt.data.findUser["type"]);
      localStorage.setItem("usertype", resultt.data.findUser["type"]);
    }
    // eslint-disable-next-line
  }, [resultt])
  //console.log(person);
  let aika = Date.now();
  aika = aika + 60 * 60000;
  const pvm = new Date(aika).toString();
  ////console.log(pvm)
  const getActivation = useQuery(GET_ACTIVATIONCODE, {
    variables: { email: email + "|||||" + pvm },
  });

  useEffect(() => {
    const token = getActivation;
    if (token.data !== undefined) {
      //console.log(token.data.getActivationcode.message);
      setCode(token.data.getActivationcode.message);
    }
    //.previousData.getActivationcode.message)
  }, [email, getActivation]);
  const submit = async (event) => {
    event.preventDefault();
    //const saltRounds = 17
    //const passwordhash = await bcryptjs.hash(password, saltRounds)
    //const passwordhash=password
    //var salt = bcryptjs.genSaltSync(12)
    //const passwordhash = await bcryptjs.hash(password, salt)
    ////console.log(passwordhash)
    if (rndnum.length > 3) {
      try {
        saveCode({
          variables: { email, code: rndnum },
        });
      } catch (error) {
        setError(error);
        setUsererror(true);
      }
    } else {
      setUsererror(true);
    }
    try {
      sendEmail({
        variables: {
          to: email,
          header:
            "Kunta.live -  Resetoi salasanasi / Reset your password / Återställ ditt lösenord",
          text:
            "Resetoi salasanasi osoitteessa/ At / På / https://kunta.live/newpassword " +
            "Koodi/code/koden: " +
            code +
            "    Varmistustunniste: / Verification ID: / Verifierings-ID: " +
            rndnum,
        },
        //"Kiitos rekisteröitymisestä / Thank you for registering / Tack för din registrering"
      });
    } catch (error) {
      setError(error);
    }
    //event.preventDefault()
    setSubmitted(true);
    //onLogin("oleppani")
    //history.push("/")
  };
  /*let rnd = Math.floor(Math.random() * 1000000) + 1
  //console.log(rndnum)*/
  //lähetetään urlissa koodi jossa kryptattu aikaleima ja meiliosoite, lisäksi lähetetään koodi, tietokantaan kirjoitetaan koodi.linkki voimassa 60min. avattaessa tarkastetaan että aikaa jäljellä, koodi täsmää ja sen jälkeen syötetään salasana kaksi kertaan ja tallennetaan kantaan

  if (emailerror) {
    return (
      <>
        <MKBox
          minHeight="23vh"
          width="100%"
          sx={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "2500px 500px",
            backgroundPosition: "top",
            display: "grid",
            placeItems: "center",
          }}
        />
        <MKBox pt={6} px={1} mt={6}>
          <Container>
            <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
              <MKTypography
                variant="h1"
                color="dark"
                mt={-6}
                mb={1}
                sx={({ breakpoints, typography: { size } }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: size["3xl"],
                  },
                })}
              >
                Kirjaudu{" "}
              </MKTypography>
              <MKTypography
                variant="body1"
                color="dark"
                textAlign="center"
                px={{ xs: 6, lg: 12 }}
                mt={1}
              >
                <h2>{t("headers.forget")}</h2>
                {t("common.emailerror")}
                <br />
                <br />
                <a href="/">{t("common.tostart")}</a>
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
      </>
    );
  }
  if (usererror) {
    return (
      <>
        <MKBox
          minHeight="23vh"
          width="100%"
          sx={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "2500px 250px",
            backgroundPosition: "top",
            display: "grid",
            placeItems: "center",
          }}
        />
        <MKBox pt={6} px={1} mt={6}>
          <Container>
            <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
              <MKTypography
                variant="h1"
                color="dark"
                mt={-6}
                mb={1}
                sx={({ breakpoints, typography: { size } }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: size["3xl"],
                  },
                })}
              >
                Kirjaudu{" "}
              </MKTypography>
              <MKTypography
                variant="body1"
                color="dark"
                textAlign="center"
                px={{ xs: 6, lg: 12 }}
                mt={1}
              >
                <h2>{t("headers.forget")}</h2>
                {t("common.usererror")}
                <br />
                <br />
                <a href="/">{t("common.tostart")}</a>
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
      </>
    );
  }
  if (codeerror) {
    return (
      <>
        <MKBox
          minHeight="23vh"
          width="100%"
          sx={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "2500px 250px",
            backgroundPosition: "top",
            display: "grid",
            placeItems: "center",
          }}
        />
        <MKBox pt={6} px={1} mt={6}>
          <Container>
            <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
              <MKTypography
                variant="h1"
                color="dark"
                mt={-6}
                mb={1}
                sx={({ breakpoints, typography: { size } }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: size["3xl"],
                  },
                })}
              >
                Kirjaudu{" "}
              </MKTypography>
              <MKTypography
                variant="body1"
                color="dark"
                textAlign="center"
                px={{ xs: 6, lg: 12 }}
                mt={1}
              >
                <h2>{t("headers.forget")}</h2>
                {t("common.usererror")}
                <br />
                <br />
                <a href="/">{t("common.tostart")}</a>
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
      </>
    );
  }
  if (submitted) {
    return (
      <>
        <MKBox
          minHeight="23vh"
          width="100%"
          sx={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "2500px 250px",
            backgroundPosition: "top",
            display: "grid",
            placeItems: "center",
          }}
        />
        <MKBox pt={6} px={1} mt={6}>
          <Container>
            <Grid container item xs={12} lg={7} justifyContent="center" mx="auto">
              <MKTypography
                variant="h1"
                color="dark"
                mt={-6}
                mb={1}
                sx={({ breakpoints, typography: { size } }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: size["3xl"],
                  },
                })}
              >
                <h3>{t("headers.forget")}</h3>
              </MKTypography>
              <MKTypography
                variant="body1"
                color="dark"
                textAlign="center"
                px={{ xs: 6, lg: 12 }}
                mt={1}
              >
                <h2>{t("headers.forget")}</h2>
                {t("common.formok")}
                <br />
                <br />
                <a href="/">{t("common.tostart")}</a>
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
      </>
    );
  } else {
    return (
      <>
        <MKBox
          minHeight="23vh"
          width="100%"
          sx={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "2500px 250px",
            backgroundPosition: "top",
            display: "grid",
            placeItems: "left",
          }}
        />
        <MKBox pt={6} px={1} mt={6}>
          <Container>
            <Grid container item xs={12} lg={7} justifyContent="left" mx="auto">
              <MKTypography
                variant="h1"
                color="dark"
                mt={-6}
                mb={1}
                sx={({ breakpoints, typography: { size } }) => ({
                  [breakpoints.down("md")]: {
                    fontSize: size["3xl"],
                  },
                })}
              >
                <h3>{t("headers.forget")}</h3>
              </MKTypography>
              <MKTypography
                variant="body1"
                color="dark"
                textAlign="left"
                px={{ xs: 6, lg: 12 }}
                mt={1}
              >
                <form onSubmit={submit}>
                  <div>
                    {t("common.forget")}
                    <br />
                    <br />
                    {t("common.email")}
                    <TextField value={email} onChange={({ target }) => setEmail(target.value)} />
                  </div>
                  <br />
                  <div>
                    <ReCAPTCHA
                      sitekey="6Lf6wLIaAAAAAORH1jwBkpv1NzwvaBYa9mpn39GP"
                      onChange={onChange}
                    />
                  </div>
                  <Button
                    style={{ backgroundColor: "#07575B", color: "#C4DFE6", fontSize: "14px" }}
                    type="submit"
                    disabled={!verified}
                    executing={executing}
                    submitted={submitted}
                  >
                    {submitted ? t("common.done") : executing ? "Verifying" : t("common.order")}
                  </Button>
                  <br />
                  <br />
                  <Link
                    {...{
                      component: RouterLink,
                      to: "/register",
                      style: { textDecoration: "none" },
                    }}
                  >
                    {t("common.registration")}
                  </Link>
                </form>
              </MKTypography>
            </Grid>
          </Container>
        </MKBox>
      </>
    );
  }
};

export default ForgetPassword;
